import { escrowOfficerCard, withApnBesideYearBuilt } from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const CAOverrides: OfferLocaleOverrides = {
  locale: 'CA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: withApnBesideYearBuilt,
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.map((prop) => {
                    if (prop.from === 'property.assessorParcelNumber') {
                      return {
                        ...prop,
                        to: 'property.assessorParcelNumber',
                      };
                    }
                    return prop;
                  }),
              },
            },
            assessorParcelNumber: {
              name: 'property.assessorParcelNumber',
              entity: 'property',
              type: 'text',
              label: 'APN Number',
              placeholderText: '',
            },
          },
        },
        emdCard: {
          innerTitle: 'Initial Deposit',
          fields: {
            emdHolderCompanyName: {
              label: 'Escrow Company Name',
            },
            emdAmount: {
              label: 'Amount',
            },
            numbersDaysEmdDue: {
              label: 'Number of Days After Acceptance Initial Deposit is Due',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        escrow: {
          ...escrowOfficerCard,
          order: -1,
        },
      },
    },
  },
};
